/*global google  */

class GMapPopup {

  constructor( position, content ) {

    var Popup = function(position, content) {

      this.position = position;

      var pixelOffset = document.createElement('div');
      pixelOffset.appendChild(content);

      this.anchor = document.createElement('div');
      this.anchor.appendChild(pixelOffset);
      //this.anchor.setZIndex(3000);

      // Optionally stop clicks, etc., from bubbling up to the map.
      this.stopEventPropagation();

    };

    // Test via a getter in the options object to see if the passive property is accessed
    var supportsPassive = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function() {
          supportsPassive = true;
        },
      });
      window.addEventListener('testPassive', null, opts);
      window.removeEventListener('testPassive', null, opts);
    } catch (e) {
      //nothing
    }


    // NOTE: google.maps.OverlayView is only defined once the Maps API has
    // loaded. That is why Popup is defined inside initMap().
    Popup.prototype = Object.create(google.maps.OverlayView.prototype);

    /** Called when the popup is added to the map. */
    Popup.prototype.onAdd = function() {
      this.getPanes().floatPane.appendChild(this.anchor);
    };

    /** Called when the popup is removed from the map. */
    Popup.prototype.onRemove = function() {
      if (this.anchor.parentElement) {
        this.anchor.parentElement.removeChild(this.anchor);
      }
    };

    /** Called when the popup needs to draw itself. */
    Popup.prototype.draw = function() {
    
      var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
      
      this.anchor.style.left = divPosition.x + 'px';
      this.anchor.style.top = divPosition.y + 'px';
      // Hide the popup when it is far out of view.
      /*var display =
        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
          'block' :
          'none';

      if (display === 'block') {
      }

      if (this.anchor.style.display !== display) {
        this.anchor.style.display = display;
      }*/
    };

    /** Stops clicks/drags from bubbling up to the map. */
    Popup.prototype.stopEventPropagation = function() {
      var anchor = this.anchor;
      anchor.style.cursor = 'auto';

      ['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart',
      'pointerdown']
      .forEach(function(event) {
        anchor.addEventListener(event, function(e) {
          e.stopPropagation();
        }, supportsPassive ? { passive: true } : false);
      });
    };
    Popup.prototype.close = function() {
      $(this.anchor).removeClass('active');
    };
    Popup.prototype.open = function() {
      $(this.anchor).addClass('active');
    };

    return new Popup(position, content);
  }
}
export default GMapPopup;



// WEBPACK FOOTER //
// ./scripts/util/GMapPopup.js